export default "__VITE_ASSET__Ba$Pf55V__"